// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3Gibs","addWidgetButton":"Header_addWidgetButton__20Ps8","dashboardTabs":"Header_dashboardTabs__29aO6","active":"Header_active__daFxT"};